import React from 'react';
import * as PropTypes from 'prop-types';

import { memoCallback } from '../../utils';
import { RequestWrapper } from './styled-components';
import { RequestHeader } from '../../containers/requests-list-item';

const Request = (props) => {
  const {
    type,
    status,
    contact,
    contacts,
  } = props;

  const contactsData = contact ? [contact] : contacts;

  return (
    <RequestWrapper
      {...{
        type,
        status,
      }}
    >
      <RequestHeader
        {...props}
        contacts={contactsData}
      />
    </RequestWrapper>
  );
};

Request.propTypes = {
  labels: PropTypes.array.isRequired,
  status: PropTypes.object,
  type: PropTypes.string,
  contact: PropTypes.object,
  contacts: PropTypes.array,
};

Request.defaultProps = {
  type: 'requests',
  status: {},
  contact: null,
  contacts: [],
};

const shouldComponentUpdate = (prevProps, nextProps, omitItems = ['isOpen', 'innerRef']) =>
  memoCallback(prevProps, nextProps, omitItems);

export default React.memo(Request, shouldComponentUpdate);



// WEBPACK FOOTER //
// ./src/components/requests-list-item/index.js